import { useGlobalContext } from '~/context/GlobalContext';
import { IChatRoom } from '~/types/common';
import { useViewportResize } from '~/hooks/useViewportResize';
import { useState, memo, useEffect, useRef } from 'react';
import { CloseIcon, OptionsIcon, UsersIcon } from '../Icons/Icons';
import classNames from 'classnames';
import styles from './RoomOptionsContainer.module.css';

const RoomOptionsContainer = memo(() => {
  const { context, setContext } = useGlobalContext();
  const resize = useViewportResize();
  const [isOpen, setIsOpen] = useState(false);

  // Ref do całego kontenera opcji
  const containerRef = useRef<HTMLDivElement>(null);

  // --- LOGIKA ZAMYKANIA POZA OBSZAREM ---
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (
        isOpen &&
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    // Dodajemy nasłuchiwanie tylko gdy menu jest otwarte
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [isOpen]);

  const closeRoom = (currentRoom: IChatRoom | null) => {
    if (!currentRoom) return;
    window.dispatchEvent(new CustomEvent('closeRoom', {
      bubbles: true,
      detail: { type: 'closeRoom', room: currentRoom },
    }));
    setIsOpen(false);
  };

  const showPeople = (room: any) => {
    setContext((prev: any) => ({
      ...prev,
      activeSidebarId: "people"
    }));
  };

  if (context.activeSidebarId || !context.room) return null;

  return (
    <div
      ref={containerRef} // Przypisanie refa
      data-component="RoomOptionsContainer"
      className={classNames(styles.roomOptionsContainer, {
        [styles.isOpen]: isOpen
      })}
      style={{
        transform: resize.isKeyboardOpen
          ? `translateY(${(resize.initialHeight ?? resize.height) - resize.height}px)`
          : 'translateY(0)'
      }}
    >
      <button
        className={styles.trigger}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Opcje pokoju"
      >
        <OptionsIcon />
      </button>

      {/* Panel opcji */}
      <div className={styles.panel}>
        <div className={styles.roomNameWrapper}>
          <div>Pokój: </div>
          <div className={styles.roomName}>{context.room.name}</div>
        </div>

        <div className={styles.menuList}>
          <button className={styles.peopleBtn} onClick={showPeople}>
            <UsersIcon className={styles.usersIcon} />
            <div className={styles.peopleText}>Osoby</div>
          </button>
          <button className={styles.leaveBtn} onClick={() => closeRoom(context.room)}>
            <CloseIcon className={styles.closeIcon}/>
            <div className={styles.leaveText}>Opuść pokój</div>
          </button>
        </div>
      </div>

      {/* Opcjonalny Backdrop (można zostawić dla pewności na UI) */}
      {isOpen && <div className={styles.backdrop} onClick={() => setIsOpen(false)} />}
    </div>
  );
});

RoomOptionsContainer.displayName = 'RoomOptionsContainer';
export default RoomOptionsContainer;